import { motion } from 'framer-motion';

interface DayStats {
  date: Date;
  amount: number;
  isWeekend: boolean;
  dayName: string;
}

interface ExpensiveDayBoxProps {
  dayStats: DayStats;
}

export const ExpensiveDayBox = ({ dayStats }: ExpensiveDayBoxProps) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', { 
      month: 'short',
      day: 'numeric'
    }).format(date);
  };

  return (
    <div className="bg-white rounded-xl p-4 border-2 border-[#221A51] shadow-[4px_4px_0px_0px_#221A51]">
      <div className="text-[#221A51]/60 text-sm mb-3">Most Expensive Day</div>
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="space-y-2"
      >
        <div className="flex items-center justify-between">
          <div className="text-2xl font-black text-[#9B86EA]">
            {formatDate(dayStats.date)}
          </div>
          <div className="text-base font-bold text-[#221A51]">
            {formatCurrency(dayStats.amount)}
          </div>
        </div>
        
        <div className="text-sm text-[#221A51]/80">
          {dayStats.isWeekend ? (
            <>Testing was a <span className="font-bold">{dayStats.dayName}</span> 😅</>
          ) : (
            <>On a <span className="font-bold">{dayStats.dayName}</span> too 🤮</>
          )}
        </div>
      </motion.div>
    </div>
  );
};
